import {
    ButtonLink,
    createButtonLink,
    IButtonLinkBusinessLogic,
} from '@vfde-brix/ws10/button-link';
import {
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackingInformation,
    TrackingInformationTrigger,
    TrackingInformationUiType,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';
import { createComponentById } from '@vfde-brix/ws10/core';
import { GIGADEPOT_ICON_TEXT_LINK } from 'Container/App/constants';

/**
 * Mount Button Link component
 */
export const mountGigaDepotButtonLink = (): ButtonLink | null => {
    const business: IButtonLinkBusinessLogic = {
        onClick: (_event, href, trackingName) => {
            const { eventType, eventPayload } = createTrackingPayloadForButtonLink(trackingName || href || '');

            return trackIt(eventType, eventPayload);
        },
    };

    return createComponentById(createButtonLink, GIGADEPOT_ICON_TEXT_LINK, business);
};

/**
 * Create tracking payload for ButtonLink
 */
export const createTrackingPayloadForButtonLink = (trackingName: string): { eventType: TrackType, eventPayload: TrackingInformation } => ({
    eventType: TrackType.Information,
    eventPayload: {
        /* eslint-disable @typescript-eslint/naming-convention, camelcase */
        information_action: TRACKING_INFORMATION_ACTION_REVEAL,
        information_name: trackingName,
        information_ui_type: TrackingInformationUiType.Accordion,
        information_trigger: TrackingInformationTrigger.Anchor,
        /* eslint-enable @typescript-eslint/naming-convention, camelcase */
    },
});
